import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormBuilder, Validators} from '@angular/forms';

import {UserSessionService} from 'src/app/tinea-components/okta/services/session/user-session.service';
import {GlobalUtil} from 'src/app/services/utils/global.util';

@Component({
    selector: 'app-modal-export-request',
    templateUrl: './modal-export-request.component.html',
    styleUrls: ['./modal-export-request.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class ModalExportRequestComponent implements OnInit {
    emailList: string[] = [];
    btnDisabled = false;
    messageSendSuccess = '';

    detailForm = this.fb.group({
        email: this.fb.control('', Validators.pattern(GlobalUtil.REGLEX_EMAIL))
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<ModalExportRequestComponent>,
        private fb: UntypedFormBuilder,
        private userSessionService: UserSessionService,
    ) {
    }

    ngOnInit(): void {
        this.emailList.push(this.userSessionService.getUser().email);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    addEmail() {
        const emailForm = this.emailForms?.value.toLowerCase().trim();
        if (emailForm !== '' && this.emailForms?.valid) {
            if (this.emailList.indexOf(emailForm) === -1) {
                this.emailList.push(emailForm);
            }
            this.btnDisabled = false;
        }
    }

    removeEmail(emailRemove: string) {
        this.emailList = this.emailList.filter(email => email !== emailRemove);
        this.btnDisabled = this.emailList.length === 0;
    }

    get f() {
        return this.detailForm.controls;
    }

    get emailForms() {
        return this.detailForm.get('email');
    }

    exportRequest() {
        // TODO
    }
}
